import type { DestinationUrlInput } from 'features/campaign/campaign.types';
import { LINK_VALIDATORS } from './constants';

/**
 * Validates a link value based on its type
 *
 * @param linkType - The type of link (asin, browse, deals, manual)
 * @param linkValue - The value to validate
 * @returns An object with isValid boolean and optional error message
 */
export const validateLinkValue = (
  linkType: DestinationUrlInput,
  linkValue: string,
): {
  isValid: boolean;
  errorMessage?: string;
} => {
  const validator = LINK_VALIDATORS[linkType];
  if (!validator) {
    return {
      errorMessage: 'Unknown link type',
      isValid: false,
    };
  }

  const validationResult = validator(linkValue);

  if (typeof validationResult === 'string') {
    return {
      errorMessage: validationResult || undefined,
      isValid: validationResult === '',
    };
  }
  if (validationResult === undefined) {
    return {
      isValid: true,
    };
  }
  return {
    errorMessage: String(validationResult),
    isValid: false,
  };
};
